import { getFieldState } from 'src/components/10-atoms/form/hooks/useFieldState/utils';
import useFormState from 'src/components/10-atoms/form/hooks/useFormState';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { useAddNoteTabMutation } from 'src/modules/exam-preparation/graphql/noteTabs/create';
import { useUpdateNoteTabMutation } from 'src/modules/exam-preparation/graphql/noteTabs/update';
export default function useData(noteID, noteTab) {
    const [createMutationState, createMutationActions] = useAddNoteTabMutation();
    const [updateMutationState, updateMutationActions] = useUpdateNoteTabMutation();
    const [formState, formActions] = useFormState({
        fields: {
            title: getFieldState(noteTab?.data.title ?? ''),
        },
    }, {
        fieldValidations: {
            title({ value }) {
                if (!value || value.trim().length === 0) {
                    return 'Title is required';
                }
                if (value.length > 200) {
                    return 'Title cannot exceed 200 characters';
                }
                return true;
            },
        },
    });
    const handleSubmit = useStableCallback(() => {
        if (formActions.validateForm()) {
            const data = {
                title: formState.fields.title.value.trim(),
            };
            if (noteTab) {
                // Update mode
                updateMutationActions.submit({
                    variables: {
                        noteTabID: noteTab.id,
                        data: {
                            ...data,
                            version: noteTab.data.version,
                        },
                    },
                });
            }
            else {
                // Create mode
                createMutationActions.submit({
                    variables: {
                        noteID,
                        data,
                    },
                });
            }
        }
    });
    const state = {
        form: formState,
        createMutation: createMutationState,
        updateMutation: updateMutationState,
    };
    const actions = {
        form: formActions,
        handleSubmit,
    };
    return [state, actions];
}
